import Store from './Store';
import Storage from '../protocol/Storage';

/**
 * Extends the functionality of Store by loading the initial
 * state from localStorage and writing state changes to localStorage.
 */
export default class PersistentStore extends Store {
  constructor(storeName: string = 'GLOBAL', initialState: Map<any, any> = new Map()) {
    try {
      const json = Storage.get(PersistentStore.getPersistenceKey(storeName));
      const data = json ? JSON.parse(json) : {};
      Object.keys(data).forEach((key) => {
        const value = data[key];
        if (value) {
          initialState.set(key, value);
        }
      });
    } catch (err) {
      // no op
    }

    super(storeName, initialState);
  }

  static getPersistenceKey(storeName: string) {
    return `Store:${storeName}`;
  }

  put(name: string, data: any) {
    super.put(name, data);
    this.persist();
  }

  /**
   * Iterates over all items in the store. If the item is json-serializeable
   * it gets written to localStorage.
   */
  persist() {
    const keys = [];
    this.map.forEach((value, key) => {
      try {
        JSON.stringify(value);
        keys.push(key);
      } catch (err) {
        // no op
      }
    });

    const data = keys.reduce((data, key) => {
      data[key] = this.map.get(key);
      return data;
    }, {});

    Storage.set(PersistentStore.getPersistenceKey(this.storeName), JSON.stringify(data));
  }
}
